// AuthGuard.tsx
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useGlobalContext } from './store/GlobalContext';
import { Spin } from 'antd';

const AuthGuard: React.FC = () => {
  const { isAuthenticated, loading } = useGlobalContext();

  // Show a spinner while loading authentication state
  if (loading) {
    return <Spin tip="Loading..." style={{ display: 'flex', justifyContent: 'center', marginTop: '20%' }} />;
  }

  // Redirect to login if not authenticated
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

export default AuthGuard;
